module.exports = __webpack_public_path__ + "static/23-dade77ddab05be89db9b9df36e3856bf.png";